import axios from 'axios';
import EnvConfig from '../../../../../config/client';

export default function ajaxAppender(logEvent, jwtToken, url) {
  const request = {
    url: url || '/log',
    method: 'post',
    data: logEvent,
    timeout: EnvConfig.axios.defaultTimeout,
    headers: {
      'Content-Type': 'application/json',
      ...(jwtToken && { Authorization: jwtToken }),
    },
  };
  axios.request(request).catch(() => {
    // Logging errors are ignored.
  });
}
